module.exports = __webpack_public_path__ + "static/media/Slide5.f2b54616.jpeg";